import axios from 'axios';
import Alert from 'react-s-alert';
import { onWaiting, getFirstMessage } from './Actions';

class Api {
    constructor() {
        this.instance = axios.create({
            baseURL: process.env.REACT_APP_END_POINT,
            timeout: 30000,
            transformRequest: this.transform,
            headers: {}
        })
    }

    getToken() {
        let token = sessionStorage.getItem('token');
        if(!token) return false;

        return token;
    }

    post(url, params, dispatch) {

        let newUrl = `${url}?token=${this.getToken()}`;

        if(url.indexOf('?') > -1){
            newUrl = `${url}&token=${this.getToken()}`
        }

        if(!this.getToken()) {
            newUrl = url;
        }

        return this.instance.post(newUrl, params)
            .then(response => {
                const { data } = response
                return data;
            })
            .catch(err => {
                const { status, data } = err;
  
                if(err.status === 422){
                    const error = Object.keys(err.data.errors).map(item => {
                        return err.data.errors[item];
                    });
                    Alert.error(error[0][0]);
                }

                if([401,404,400].indexOf(status) >= 0) {
                    Alert.error(data.error)
                }

                if(!status) {
                    Alert.error('Oops! Something went wrong')
                }

                dispatch(onWaiting(false))
                return false;
            })
    }

    put(url, params, dispatch) {

        let newUrl = `${url}?token=${this.getToken()}`;

        if(url.indexOf('?') > -1){
            newUrl = `${url}&token=${this.getToken()}`
        }

        if(!this.getToken()) {
            newUrl = url;
        }

        return this.instance.put(newUrl, params)
            .then(response => {
                const { data } = response
                return data;
            })
            .catch(err => {
                const { status, data } = err;
                if(err.status === 422){
                    Alert.error(getFirstMessage(err.data.errors)[0])
                }

                if(status === 401){
                    Alert.error(data.data.message)
                }

                if(status === 404){
                    Alert.error(data.data.message)
                }

                dispatch(onWaiting(false))
                return false;
            })
    }

    get(url, params, dispatch) {

        return this.instance.get(url, {
            params: {
                token: this.getToken(),
                ...params
            }
        })
        .then(response => {
            const { data } = response
            return data;
        })
        .catch(err => {

            if(err.status === 422){
                Alert.error(getFirstMessage(err.data.errors)[0])
            }

            if([401,400].indexOf(err.status) >= 0){
                Alert.error(err.data.message)
            }

            if(dispatch) {
                dispatch(onWaiting(false))
            }
            return false;
        })

    }

    transform(object) {
        let arr = [];
        for(let p in object) {
            if(object.hasOwnProperty(p)) {
                arr.push(encodeURIComponent(p) + "=" + encodeURIComponent(object[p]))
            }
        }

        return arr.join("&");
    }
}

export default new Api();


// WEBPACK FOOTER //
// ./src/Api.js